<script lang="ts">
export interface PhxsgClusterProps {
  spacing?: string | number;
  align?: 'start' | 'center' | 'end' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  use?: keyof HTMLElementTagNameMap;
}
</script>

<script setup lang="ts">
const { use = 'div' } = defineProps<PhxsgClusterProps>();
</script>

<template>
  <component
    :is="use"
    :class="[
      'phxsg-cluster',
      {
        [`phxsg-cluster--spacing-${spacing}`]: spacing,
        [`phxsg-cluster--align-${align}`]: align,
        [`phxsg-cluster--justify-${justify}`]: justify,
      },
    ]"
  >
    <slot />
  </component>
</template>

<style src="./cluster.css" />
